import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Department } from '../models/department';
import { WorkFlow } from '../models/workflow';
import { Employee } from '../models/employee';

@Injectable({
  providedIn: 'root'
})
export class WorkFlowService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'WorkFlow/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllWorkFlow(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllWorkFlows?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewWorkFlow(WorkFlowID?: string): Observable<Array<WorkFlow>> {
      return this.httpService.get(this.apiEndpoint + '/viewWorkFlow/' + (WorkFlowID ? WorkFlowID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveWorkFlow(WorkFlows: WorkFlow): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveWorkFlow/', WorkFlows).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deleteWorkFlow(WorkFlowID?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteWorkFlow/' + (WorkFlowID ? WorkFlowID : '00000000-0000-0000-0000-000000000000'), WorkFlowID).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    deleteWorkFlowDetails(WorkFlowDetails_Id?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteWorkFlowDetails/' + (WorkFlowDetails_Id ? WorkFlowDetails_Id : '00000000-0000-0000-0000-000000000000'), WorkFlowDetails_Id).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    checkDuplication(WorkFlowCode?: string,WorkFlowID?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?Code=' + (WorkFlowCode ? WorkFlowCode : '')+ '&WorkFlowID=' + (WorkFlowID ? WorkFlowID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
          return result; 
      }));
    }

    checkEmail(Emailid?: string,WorkFlowID?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&WorkFlowID=' + (WorkFlowID ? WorkFlowID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
          return result; 
      }));
    }

    getAllApprovers(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Employee>> { 
      return this.httpService.get(this.apiEndpoint + '/getAllApprovers?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0)  + '&pageNumber=' + (pagenumber ? pagenumber : 0) +  '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
        if (result.Success) {        
          return result.Data;
        } else {
          return [];
        }
      }));
    } 
  
  }

